import React from 'react'

const ShippingInfo = () => <div>{/*<img alt="cataloge" src={`${require('../../assets/ZadigCatalogue.jpg')}`} />*/}</div>

export default ShippingInfo
